const Chevron = ({ scale = 1 }: { scale?: number }) => {
  return (
    <svg width={16 * scale} height={16 * scale} viewBox="0 0 16 16" fill="none">
      <path
        d="M9.24268 12.6L4.64648 8.00381L9.24268 3.40762"
        stroke={"var(--svg-color, #000)"}
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Chevron;
